module.exports = __webpack_public_path__ + "static/MOD1-4a624e0a99d3de90408414b4f5099d29.jpg";